<template>
    <div>
        <b-container fluid>
            <b-breadcrumb class="mt-3 mb-3" :items="breadcrumb_items" />
            <b-button v-if="$store.state.user_obj.account_type != 'client_user'" class="btn-action mb-3" size="sm"
                variant="info" @click="toggleActiveHold" >Toggle Active/Hold</b-button>

            <b-card class="mb-1">
                <b-row>
                    <b-col class="col-2">
                        <strong>Queue Name</strong>
                    </b-col>
                    <b-col v-if="pq_detail">{{ pq_detail.queue_name }}</b-col>
                    <b-col v-if="!pq_detail">-</b-col>
                </b-row>

                <b-row>
                    <b-col class="col-2">
                        <strong>Printed At</strong>
                    </b-col>
                    <b-col v-if="pq_detail && pq_detail.printed_at">{{
                        displayDate(pq_detail.printed_at)
                        }}</b-col>
                    <b-col v-if="!pq_detail || !pq_detail.printed_at">-</b-col>
                </b-row>

                <b-row>
                    <b-col class="col-2">
                        <strong>Printed By</strong>
                    </b-col>
                    <b-col v-if="pq_detail && pq_detail.printed_by">{{
                        pq_detail.printed_by
                        }}</b-col>
                    <b-col v-if="!pq_detail || !pq_detail.printed_by">-</b-col>
                </b-row>

                <b-row>
                    <b-col class="col-2">
                        <strong># of Printed</strong>
                    </b-col>
                    <b-col v-if="pq_detail">{{
                        pq_detail.printed_count
                        }}</b-col>
                    <b-col v-if="!pq_detail">-</b-col>
                </b-row>

                <b-row>
                    <b-col class="col-2">
                        <strong>Packing Sector</strong>
                    </b-col>
                    <b-col v-if="pq_detail && pq_detail.packing_sectors.length > 0">
                        <ul v-for="(item, index) in pq_detail.packing_sectors" :key="index">
                            <li>{{ item }}</li>
                        </ul>
                    </b-col>
                    <b-col v-if="
                        !pq_detail || pq_detail.packing_sectors.length == 0
                    ">-</b-col>
                </b-row>

                <b-row>
                    <b-col class="col-2">
                        <strong>Client</strong>
                    </b-col>
                    <b-col v-if="pq_detail && pq_detail.client_names.length > 0">
                        <ul v-for="(item, index) in pq_detail.client_names" :key="index">
                            <li>{{ item }}</li>
                        </ul>
                    </b-col>
                    <b-col v-if="!pq_detail || pq_detail.client_names.length == 0">-</b-col>
                </b-row>
                <b-row>
                    <b-col class="col-2">
                        <strong>Remark</strong>
                    </b-col>
                    <b-col v-if="pq_detail && pq_detail.remark">{{
                        pq_detail.remark
                        }}</b-col>
                    <b-col v-if="!pq_detail || !pq_detail.remark">-</b-col>
                </b-row>
                <b-row>
                    <b-col class="col-2">
                        <strong>Status</strong>
                    </b-col>
                    <b-col>{{pq_detail.status}}</b-col>
                </b-row>
            </b-card>

            <h4 class="mt-3">
                Trackings
            </h4>

            <b-table responsive small outlined striped hover v-if="pq_detail" :items="pq_detail.trackings"
                :fields="tracking_fields">
                <template v-slot:head(chk_box)="data">
                    <b-form-checkbox size="sm" plain id="chkbox_all" value="all"
                        v-model="check_all_rows"></b-form-checkbox>
                </template>
                <template v-slot:cell(chk_box)="data">
                    <b-form-checkbox size="sm" class="chkbox_row" plain :id="'chkbox_row_' + data.index"
                        v-model="data.item.is_checked"></b-form-checkbox>
                </template>
                <template v-slot:cell(status)="data">
                    {{ data.item.status }}
                    <span v-if="data.item.other_reason">
                        <br />
                        [{{ data.item.other_reason }}]
                    </span>
                </template>

                <template v-slot:cell(attention)="data">
                    <span v-if="!data.item.attention_driver">{{
                        data.item.attention
                        }}</span>
                    <span v-if="data.item.attention_driver">{{
                        data.item.attention_driver
                        }}</span>
                </template>

                <template v-slot:cell(phone)="data">
                    <span v-if="!data.item.phone_driver">{{
                        data.item.phone
                        }}</span>
                    <span v-if="data.item.phone_driver">{{
                        data.item.phone_driver
                        }}</span>
                </template>

                <template v-slot:cell(carried_by)="data">
                    <span v-if="
                        data.item.carried_by && data.item.carried_by != ''
                    ">
                        <span v-if="
                            $store.state.user_obj.account_type !=
                            'client_user'
                        ">
                            {{ data.item.carried_by }}
                        </span>
                        <span v-if="
                            $store.state.user_obj.account_type ==
                            'client_user'
                        ">
                            -
                        </span>
                    </span>
                </template>

                <template v-slot:cell(pod_image)="data">
                    <div style="text-align: center" v-if="
                        checkPermission(
                            $store.state.user_obj,
                            'Delivery Management',
                            'Delivery Status',
                            'POD Records',
                            true
                        )
                    ">
                        <b-button class="btn-action" size="sm" variant="info" v-if="data.item.pod_image"
                            @click="showPod(data.item)">{{ data.item.pod_type }}</b-button>
                        <span v-if="!data.item.pod_image">/</span>
                    </div>
                </template>

                <template v-slot:cell(ready_for_packing)="data">
                    <div>
                        <span v-if="data.item.ready_for_packing == '0'" class="dot_red"></span>
                        <span v-if="data.item.ready_for_packing == '1'" class="dot_green"></span>
                    </div>
                </template>

                <template v-slot:cell(schedule_date)="data">
                    <span v-if="!data.item.reschedule_delivery_date">{{
                        displayDate(data.item.schedule_date)
                        }}</span>
                    <span v-if="data.item.reschedule_delivery_date">{{ data.item.reschedule_type }}
                        {{
                            displayDate(data.item.reschedule_delivery_date)
                        }}</span>
                </template>

                <template v-slot:cell(scheduled_delivery_date)="data">
                    {{ displayDate(data.item.scheduled_delivery_date) }}
                </template>

                <template v-slot:cell(packing_queues)="data">
                    <ul v-for="(queue, i) in data.item.packing_queues" :key="i">
                        <li>{{ queue.queue_name }}</li>
                    </ul>
                </template>
            </b-table>

            <h4 class="mt-3">Documents</h4>
            <b-card>
                <div class="search_bar mb-3">
                    <b-row>
                        <b-col cols="2" class="pr-1">
                            <b-form-input id="input-small" type="text" placeholder="Document Name"
                                v-model="new_doc_record.name"></b-form-input>
                        </b-col>
                        <b-col cols="3" class="pl-0 pr-1">
                            <b-form-file v-model="new_doc_record.upload_file"
                                placeholder="Choose a file..."></b-form-file>
                        </b-col>

                        <b-col class="text-left p-0">
                            <b-button class="btn-action" variant="info" @click="onUploadFile">Upload</b-button>
                        </b-col>
                    </b-row>
                </div>
                <b-table responsive small outlined striped hover :items="document_items" :fields="document_fields">
                    <template v-slot:cell(document_name)="data">
                        <a :href="data.item.url" target="_blank">
                            {{ data.item.document_name }}
                        </a>
                    </template>

                    <template v-slot:cell(created_at)="data">
                        <div v-if="data.item.updated_by != ''">
                            {{ data.item.created_at }}
                        </div>
                    </template>
                </b-table>
            </b-card>
        </b-container>
    </div>
</template>

<script>
import moment from "moment";
import VueBarcode from "vue-barcode";

const tracking_fields = [
    {
        key: "chk_box",
        label: ""
    },
    {
        key: "client_name",
        label: "Client"
    },
    {
        key: "order_number",
        label: "Order#"
    },
    {
        key: "courier_short_name",
        label: "Courier"
    },
    {
        key: "tracking_number",
        label: "Tracking#"
    },
    {
        key: "ready_for_packing",
        label: "Ready For Packing",
        class: " center_align container-status"
    },
    {
        key: "status",
        label: "Status"
    },
    {
        key: "schedule_date",
        label: "Process Date"
    },
    {
        key: "scheduled_delivery_date",
        label: "Scheduled Date"
    },
    {
        key: "pod_image",
        label: "POD Record"
    },
    {
        key: "carried_by",
        label: "Carried by"
    },
    {
        key: "packing_queue",
        label: "Packing Queue"
    },
    {
        key: "packing_queues",
        label: "Packing Queues"
    },
    {
        key: "updated_at",
        label: "Last Updated"
    },
    {
        key: "packing_print_at",
        label: "Packing Printed"
    },
    {
        key: "waybill_print_at",
        label: "Waybill Printed"
    }
];

import global_function from "../mixins/global_function";

export default {
    name: "DeliveryNoteDetail",
    inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT"],
    mixins: [global_function],
    components: {
        barcode: VueBarcode
    },
    data() {
        return {
            pq_detail: {},
            new_doc_record: {},
            breadcrumb_items: [
                {
                    text: "Packing Queue",
                    to: { name: "packing_queue" }
                },
                {
                    text: "Detail",
                    active: true
                }
            ],
            loader: false,
            tracking_fields: tracking_fields,
            currentPage: 1,
            table_offset: 0,
            total_rows: 0,
            check_all_rows: false,
            document_items: [],
            document_fields: [
                {
                    key: "document_name",
                    label: "Document Name"
                },
                {
                    key: "created_by",
                    label: "Created By"
                },
                {
                    key: "created_at",
                    label: "Created at"
                }
            ]
        };
    },
    async created() {
        await this.getPQDetail();
        await this.getPQDoc();
        this.initialized = true;
    },
    mounted() {
        this.loader = this.$loading.show({
            isFullPage: true,
            canCancel: false
        });
    },
    watch: {
        // whenever changes, this function will run
        check_all_rows: function (new_val, old_val) {
            // this.check_all_rows = !this.check_all_rows;
            console.log("check_all_rows");
            if (!pq_detail) return;
            if (new_val == "all") {
                // Check all
                for (let i in this.pq_detail.trackings) {
                    this.pq_detail.trackings[i].is_checked = true;
                }
            } else {
                for (let i in this.pq_detail.trackings) {
                    this.pq_detail.trackings[i].is_checked = false;
                }
            }
            console.log(this.pq_detail.trackings);
        }
    },
    methods: {
        displayDate(d) {
            if (d) {
                return moment(d).format("YYYY-MM-DD");
            } else {
                return "/";
            }
        },

        async getPQDetail() {
            let response = await this.$http({
                method: "POST",
                baseURL: `${this.API_HOST}`,
                url: "packing_queue_detail_get.php",
                data: {
                    packing_queue_id: this.$route.params.packing_queue_id,
                    account_type: this.$store.state.user_obj.account_type,
                    client_id: this.$store.state.user_obj.client_id
                }
            });
            this.pq_detail = response.data.pq_detail;

            this.loader.hide();
        },

        async onUploadFile() {
            this.loader_full = this.$loading.show({
                isFullPage: true,
                canCancel: false
            });

            let formData = new FormData();
            formData.append("doc_file", this.new_doc_record.upload_file);
            formData.append("document_name", this.new_doc_record.name);
            formData.append("packing_queue_id", this.pq_detail.id);
            formData.append("user_id", this.$store.state.user_obj.user_id);

            let response = await this.$http({
                method: "POST",
                baseURL: `${this.API_HOST}`,
                url: "packing_queue_upload_document.php",
                headers: {
                    "Content-Type": "multipart/form-data"
                },
                data: formData
            });
            console.log(response);
            if (response) {
                this.loader_full.hide();
                // alert("Upload success");
                // window.location.reload();
            }
            this.new_doc_record = {};
            this.getPQDoc();
        },

        async getPQDoc() {
            let response = await this.$http({
                method: "POST",
                baseURL: `${this.API_HOST}`,
                url: "packing_queue_doc_get.php",
                data: {
                    packing_queue_id: this.$route.params.packing_queue_id,
                    account_type: this.$store.state.user_obj.account_type,
                    client_id: this.$store.state.user_obj.client_id
                }
            });
            this.document_items = response.data.packing_queue_docs;

            this.loader.hide();
        },

        async toggleActiveHold() {
            let response = await this.$http({
                method: "POST",
                baseURL: `${this.API_HOST}`,
                url: "packing_queue_toggleActiveHold.php",
                data: {
                    packing_queue_id: this.$route.params.packing_queue_id,
                    account_type: this.$store.state.user_obj.account_type,
                    client_id: this.$store.state.user_obj.client_id
                }
            });
            this.getPQDetail();

            this.loader.hide();
        },
    }
};
</script>

<style>
th,
td {
    white-space: nowrap;
}

.dev_test {
    flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/PackingQueueDetail.vue